export default __webpack_public_path__ + "static/media/header_buffer.343f3ea9.svg";